import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { MAX_PASSWORD_CHARS, MIN_PASSWORD_CHARS } from "../../../ducks/userManagement";

import { faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { Alert, ButtonGroup, ButtonToolbar, Form, FormControl, FormLabel } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";
import Modal from "react-bootstrap/Modal";
import { USER } from "../../../common/constant";
import { coalesce } from "../../../utils/ObjectUtils";
import StandardView from "../../common/StandardView";
import Visibility from "../../common/VisibleContainer";

class UserProfile extends Component {
  static propTypes = {
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    hasChanged: PropTypes.bool,

    currentPassword: PropTypes.string,
    newPassword: PropTypes.string,
    newPasswordConfirm: PropTypes.string,

    currentPasswordIsValid: PropTypes.bool,
    newPasswordIsValid: PropTypes.bool,
    newPasswordConfirmIsValid: PropTypes.bool,

    changePasswordDialogOpen: PropTypes.bool,

    propertyChange: PropTypes.func.isRequired,
    saveProfile: PropTypes.func.isRequired,
    loadProfile: PropTypes.func.isRequired,
    updatePassword: PropTypes.func.isRequired,

    intl: PropTypes.object
  };

  componentDidMount() {
    this.props.clearMessages();
    this.props.loadProfile();
  }

  render() {
    const {
      propertyChange,
      firstname,
      lastname,
      currentPassword,
      newPassword,
      newPasswordConfirm,
      currentPasswordIsValid,
      newPasswordIsValid,
      newPasswordConfirmIsValid,
      saveProfile,
      hasChanged,
      updatePassword,
      changePasswordDialogOpen
    } = this.props;

    return (
      <Visibility roles={[USER]}>
        <StandardView
          id="profile"
          titleKey="user.profile.page.title"
          actions={[
            {
              labelKey: "user.profile.button.change.password",
              onClick: () => propertyChange("changePasswordDialogOpen", true),
              variant: "warning",
              icon: <FontAwesomeIcon icon={faKey} className="me-2" />
            }
          ]}
        >
          <Form className="w-50">
            <FormGroup  className="mb-3">
              <FormLabel>
                <FormattedMessage id="user.profile.form.firstname" />
              </FormLabel>
              <FormControl
                name="firstname"
                value={coalesce(firstname, "")}
                onChange={(event) => propertyChange(event.target.name, event.target.value)}
              />
            </FormGroup>
            <FormGroup  className="mb-3">
              <FormLabel>
                <FormattedMessage id="user.profile.form.lastname" />
              </FormLabel>
              <FormControl
                name="lastname"
                value={coalesce(lastname, "")}
                onChange={(event) => propertyChange(event.target.name, event.target.value)}
              />
            </FormGroup>
            <ButtonToolbar className="w-100">
              <ButtonGroup>
                <Button onClick={() => saveProfile()} disabled={!hasChanged}>
                  <FormattedMessage id="app.common.action.save" />
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Form>
        </StandardView>

        {changePasswordDialogOpen && (
          <Modal show className="create-edit-new-project-modal">
            <Modal.Header>
              <Modal.Title>
                <FormattedMessage id={"user.profile.update.password.dialog.title"} />
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <FormGroup  className="mb-3">
                  <FormLabel>
                    <FormattedMessage id="user.profile.form.current.password" />
                  </FormLabel>
                  <FormControl
                    type="password"
                    name="currentPassword"
                    value={currentPassword || ""}
                    isValid={currentPassword && currentPasswordIsValid}
                    onChange={(event) => {
                      this.props.propertyChange("currentPassword", event.currentTarget.value);
                    }}
                  />
                </FormGroup>
                <FormGroup  className="mb-3">
                  <FormLabel>
                    <FormattedMessage id="user.profile.form.new.password" />
                  </FormLabel>
                  <FormControl
                    type="password"
                    name="newPassword"
                    value={newPassword || ""}
                    isValid={newPassword && newPasswordIsValid}
                    onChange={(event) => {
                      this.props.propertyChange("newPassword", event.currentTarget.value);
                    }}
                  />
                  {!newPasswordIsValid && (
                    <Alert variant="warning">
                      <FormattedMessage
                        id="user.profile.form.new.password.invalid.message"
                        values={{
                          MIN_PASSWORD_CHARS,
                          MAX_PASSWORD_CHARS
                        }}
                      />
                    </Alert>
                  )}
                </FormGroup>
                <FormGroup  className="mb-3">
                  <FormLabel>
                    <FormattedMessage id="user.profile.form.new.password.confirm" />
                  </FormLabel>
                  <FormControl
                    type="password"
                    name="newPasswordConfirm"
                    value={newPasswordConfirm || ""}
                    isValid={newPasswordConfirm && newPasswordConfirmIsValid}
                    onChange={(event) => {
                      this.props.propertyChange("newPasswordConfirm", event.currentTarget.value);
                    }}
                  />
                  {!newPasswordConfirmIsValid && (
                    <Alert variant="warning">
                      <FormattedMessage id="user.profile.form.new.password.confirm.invalid.message" />
                    </Alert>
                  )}
                </FormGroup>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => propertyChange("changePasswordDialogOpen", false)}>
                <FormattedMessage id="master.data.management.button.cancel" />
              </Button>
              <Button
                onClick={updatePassword}
                disabled={
                  !currentPassword ||
                  !newPassword ||
                  !newPasswordConfirm ||
                  !currentPasswordIsValid ||
                  !newPasswordIsValid ||
                  !newPasswordConfirmIsValid
                }
              >
                <FormattedMessage id="master.data.management.button.save" />
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Visibility>
    );
  }
}

export default injectIntl(UserProfile);
